import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full bg-gray-50 p-4 md:p-6">
      <div className="max-w-3xl mx-auto space-y-6">
        <Button
          variant="outline"
          onClick={() => navigate(-1)}
          className="rtl-button-icon"
        >
          חזור
          <ChevronRight className="h-4 w-4" />
        </Button>

        <div className="bg-white p-6 rounded-lg shadow-sm space-y-6">
          <h1 className="text-2xl font-bold text-right">תנאי שימוש</h1>

          <div className="space-y-4 text-right">
            <section className="space-y-2">
              <h2 className="text-xl font-semibold">הסכמה לתנאים</h2>
              <p>
                על ידי גישה ושימוש באפליקציית PlateMate, אתם מסכימים לתנאי
                השימוש המפורטים להלן. אם אינכם מסכימים לתנאים אלה, אנא הימנעו
                משימוש באפליקציה.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-semibold">רישום וחשבון משתמש</h2>
              <p>
                כדי להשתמש בשירותים מסוימים באפליקציה, עליכם ליצור חשבון. אתם
                אחראים לשמור על סודיות פרטי החשבון שלכם ולכל הפעילות המתבצעת תחת
                החשבון שלכם.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-semibold">שימוש באפליקציה</h2>
              <p>
                השימוש באפליקציה מיועד למטרות אישיות ולא מסחריות בלבד. אין
                להעתיק, לשנות, להפיץ או למכור כל חלק מהאפליקציה ללא הסכמה מפורשת
                בכתב.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-semibold">תוכן המשתמש</h2>
              <p>
                כל תוכן שאתם מעלים לאפליקציה נשאר בבעלותכם, אך אתם מעניקים לנו
                רישיון להשתמש בו לצורך הפעלת השירות. אתם אחראים לכל תוכן שאתם
                מעלים.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-semibold">הגבלת אחריות</h2>
              <p>
                האפליקציה מסופקת "כפי שהיא" ואיננו מתחייבים לזמינות או דיוק
                המידע. איננו אחראים לכל נזק ישיר או עקיף שעלול להיגרם משימוש
                באפליקציה.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-semibold">שינויים בשירות</h2>
              <p>
                אנו שומרים על הזכות לשנות או להפסיק את השירות בכל עת, עם או ללא
                הודעה מוקדמת.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-semibold">סיום שירות</h2>
              <p>
                אנו רשאים להשעות או לסיים את חשבונכם בכל עת אם נמצא שהפרתם את
                תנאי השימוש.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-xl font-semibold">יצירת קשר</h2>
              <p>
                לשאלות בנוגע לתנאי השימוש, אנא צרו קשר בכתובת:
                support@platemate.com
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
